(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

var navigation = require('./modules/navigation');
var forms = require('./modules/forms');
var bookPopUpButton = require('./modules/bookPopUpButton');

(function () {
  var DEBUG = true;

  if (!DEBUG) {
    if (!window.console) window.console = {};
    var methods = ['log', 'debug', 'warn', 'info'];
    for (var i = 0; i < methods.length; i++) {
      console[methods[i]] = function () {};
    }
  }

  console.log('🏎 Initializing website…');

  navigation();
  forms();
  bookPopUpButton();

  console.log('🏁 Website initialized!');
})();

},{"./modules/bookPopUpButton":2,"./modules/forms":3,"./modules/navigation":4}],2:[function(require,module,exports){
'use strict';

module.exports = function () {
  var $ = window.jQuery;

  // Aquí dins ja podeu posar el codi jQuery que teniu ara
  $(document).ready(function () {
    $('.close-menu-button a').on('click', function () {
      if ($('body').hasClass('openednav')) {
        $('body').addClass('closednav').removeClass('openednav');
      }
    });
  });
};

},{}],3:[function(require,module,exports){
'use strict';

module.exports = function () {
  var $ = window.jQuery;

  // Aquí dins ja podeu posar el codi jQuery que teniu ara
  $(document).ready(function () {
    if ($('.elementor-form').length > 0) {
      //autocomplete="off"
      $('.elementor-form').attr('autocomplete', 'off');
      var type;
      $('input').each(function () {
        type = $(this).prop('type');
        if (type == 'text' && type == 'email' && $(this).val() != '') {
          $(this).parent('.elementor-field-group').toggleClass('actiu', true);
        }
        var elem = $(this);
        elem.bind('propertychange change click keyup input paste', function (event) {
          elem.parent('.elementor-field-group').toggleClass('actiu', true);
        });
      });
      $('textarea').each(function () {
        if ($(this).val() != '') {
          $(this).parent('.elementor-field-group').toggleClass('actiu', true);
        }
        var elem = $(this);
        // Save current value of element
        elem.data('oldVal', elem.val());
        // Look for changes in the value
        elem.bind('propertychange change click keyup input paste', function (event) {
          elem.data('oldVal', elem.val());
          elem.parent('.elementor-field-group').toggleClass('actiu', true);
        });
      });
      $('input').on('focusout', function (e) {
        // 		    	console.log('focus Out!',$(this).val());
        if ($(this).val() == '') {
          $(this).parent('.elementor-field-group').toggleClass('actiu', false);
        }
      });
      $('textarea').on('focusout', function (e) {
        // 		    	console.log('focus Out!',$(this).val());
        if ($(this).val() == '') {
          $(this).parent('.elementor-field-group').toggleClass('actiu', false);
        }
      });
    }
  });
};

},{}],4:[function(require,module,exports){
'use strict';

module.exports = function () {
  var $ = window.jQuery;

  // Aquí dins ja podeu posar el codi jQuery que teniu ara
  $(document).ready(function () {
    var currentPos = 0;
    var url;
    var seccioid;
    //resize
    var resizeDelay = 200;
    var doResize = true;
    //zona "top" per poder tornar a dalt
    $('body').prepend('<div id="top" style="height:0;overflow:hidden;"></div>');
    //posem ara la navegació com element fixe, així no es veu quan es carrga
    $('.navigation').toggleClass('fixedelement');
    //el menú està tancat
    $('body').toggleClass('closednav', true);
    $('body').toggleClass('openednav', false);
    //OBRIR MENÚ
    function obreMenu() {
      $('body').toggleClass('closednav');
      $('body').toggleClass('openednav');
      var diferencia = $('.navigation-menu-area > .elementor-container').height() - $('.navigation-menu-area').height();
      if ($('.navigation-menu-area').height() < $('.navigation-menu-area > .elementor-container').height() && diferencia > 30) {
        $('.navigation-menu-area').toggleClass('scrollable-menu', true);
      } else {
        $('.navigation-menu-area').toggleClass('scrollable-menu', false);
      }
    }
    function calculaElements() {
      var alcada = $(window).height(); //$(".rowslider—full").height();
      var alcadaheader = $('.mainheader').height();
      var ampladaheader = $('.mainheader').width();
      //centrar text
      if ($('.rowslider—full').length > 0) {
        $('.rowslider—full .elementor-spacer-inner').css('height', alcadaheader + 'px');
      }
      //home
      if ($('.home').length < 1) {
        if ($('.admin-bar').length > 0) {
          alcadaheader += 32;
        }
        if ($('.site-main').length > 0) {
          if (ampladaheader < 768) {
            alcadaheader = $('.elementor-location-header').height();
            $('.site-main').css('padding-top', alcadaheader + 'px');
          } else {
            $('.site-main').css('padding-top', alcadaheader + 'px');
          }
        }
        if ($('.elementor-location-single').length > 0) {
          $('.elementor-location-single').css('padding-top', alcadaheader + 'px');
        }
      }
      //reservation i go up
      if (ampladaheader < 768) {
        if ($('#reservation-bar').length < 1) {
          var text = $('.mainheader__btreservation .elementor-button-text').text();
          var link = $('.contact-info a').attr('href');
          var linkreservar = $('.mainheader .elementor-button').attr('href');
          $('body').append('<div id="reservation-bar"><div class="reservation-link"><a href="' + linkreservar + '" target="">' + text + '</a></div><div class="phone-link"> <a href="' + link + '" target="_blank"><i class="fa fa-phone"></i> <span>' + text + '</span></a>' + '</div></div>');
        }
      }
      //subir
      if ($('#goup').length < 1) {
        var textsubir = $('.mainfooter .elementor-button').text();
        $('body').append('<div id="goup"><a href="#top"><span>' + textsubir + '</span></a></div>');
      }
    }

    $('.mainheader__btmenu a').click(function (e) {
      e.preventDefault();
      calculaElements();
      obreMenu();
    });
    $('.navigation__btmenu a').click(function (e) {
      e.preventDefault();
      obreMenu();
    });

    // Flag para evitar que el evento 'scroll' interfiera con nuestra animación
    var isSmoothScrolling = false;

    $('.navigation .menu li a').on('click', function (e) {
      var href = $(this).attr('href');

      // Solo intervenimos para anclas internas (#) que existan en el DOM actual
      if (href && href.indexOf('#') === 0 && href.length > 1) {
        try {
          var $target = $(href);

          if ($target.length > 0) {
            e.preventDefault();

            // Activamos el flag para que el listener de scroll no desactive las clases
            isSmoothScrolling = true;

            // Guardamos referencia al header ANTES de hacer cambios
            var $header = $('.mainheader');
            var initialHeaderHeight = $header.height();
            if ($('.admin-bar').length > 0) {
              initialHeaderHeight += 32;
            }

            // Cerramos el menú y forzamos el estado 'scrolled'
            $('html, body').css({
              'overflow': 'visible',
              'height': 'auto'
            }).removeClass('elementor-html--overflow-hidden');

            $('body').removeClass('openednav').addClass('closednav scrolled');
            $header.addClass('shrink');

            // ========== PRIMER SCROLL INMEDIATO ==========
            var initialOffset = $target.offset().top;
            var firstScrollTarget = initialOffset - initialHeaderHeight;

            $('html, body').stop(true, false).animate({
              scrollTop: firstScrollTarget
            }, 400, function () {
              // ========== SEGUNDO SCROLL DESPUÉS DE ESTABILIZAR ==========
              setTimeout(function () {
                var finalOffset = $target.offset().top;
                var finalHeaderHeight = $header.height();
                if ($('.admin-bar').length > 0) {
                  finalHeaderHeight += 32;
                }
                var finalScrollTarget = finalOffset - finalHeaderHeight;

                // Si cambió, hacer ajuste final rápido
                if (Math.abs(finalScrollTarget - firstScrollTarget) > 10) {
                  $('html, body').stop(true, false).animate({
                    scrollTop: finalScrollTarget
                  }, 300, function () {
                    isSmoothScrolling = false;
                  });
                } else {
                  isSmoothScrolling = false;
                }
              }, 800);
            });
          }
        } catch (err) {
          isSmoothScrolling = false;
        }
      }
    });

    var resizer = function resizer() {
      if (doResize) {
        calculaElements();
        doResize = false;
        clearInterval(resizerInterval);
      }
    };
    var resizerInterval; // = setInterval(resizer, resizeDelay);
    resizer();

    $(window).resize(function () {
      doResize = true;

      resizerInterval = setInterval(resizer, resizeDelay);
    });

    //shrink header
    $(document).on('scroll', function () {
      // Si estamos en medio de un scroll suave programado, no alteramos las clases
      if (isSmoothScrolling) return;

      if ($(document).scrollTop() > 100) {
        $('.mainheader').toggleClass('shrink', true);
        $('body').toggleClass('scrolled', true);
      } else {
        $('.mainheader').toggleClass('shrink', false);
        $('body').toggleClass('scrolled', false);
      }
    });
    //INICI:
    calculaElements();
  });
};

},{}]},{},[1]);
